"use client";
import { g as h } from "./nodes-C8EyMHS3.mjs";
import { c as o } from "./element-DE7VsBMX.mjs";
function v({
  currentTarget: f,
  relatedTarget: n
}, m) {
  const {
    popupElement: s,
    viewportElement: p,
    rootRef: t,
    tree: u,
    nodeId: r
  } = m, c = u ? h(u.nodesRef.current, r).some((E) => {
    var e;
    return o((e = E.context) == null ? void 0 : e.elements.floating, n);
  }) : [];
  if (!s)
    return !o(t.current, n) && !c;
  const i = s || p;
  return !o(i, f) && !o(i, n) && !o(t.current, n) && !c && !(o(i, n) && (n != null && n.hasAttribute("data-base-ui-focus-guard")));
}
export {
  v as i
};
